import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './JobDetailsPage.css';

const JobDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // This would normally come from an API or database
  const jobData = {
    1: {
      title: 'Finance + HR Intern',
      department: 'Finance & Human Resources',
      type: 'Internship',
      location: 'Noida / Remote / Hybrid',
      stipend: '₹5,000/month',
      duration: '3-6 Months (Extendable)',
      description: 'Join our dynamic team as a Finance + HR Intern and gain hands-on experience in both finance operations and human resource management.',
      responsibilities: {
        finance: [
          'Basic bookkeeping in Excel',
          'Preparing invoices, vendor payments, and other finances',
          'Tracking revenue & expenses',
          'Generating monthly financial reports',
          'Maintaining payment records for clients'
        ],
        hr: [
          'Screening candidate profiles',
          'Shortlisting and scheduling interviews',
          'Maintaining recruitment pipeline',
          'Sending offer letters & onboarding docs',
          'Maintaining employee attendance & salary sheet'
        ]
      },
      qualifications: [
        'B.Com, BBA, MBA, HR, or Finance students',
        'Freshers who want practical experience',
        'Must be comfortable with MS Excel/Google Sheets',
        'Good communication & documentation skills'
      ],
      benefits: [
        'Internship certificate',
        'Hands-on finance + HR training',
        'Letter of recommendation (if performance is good)',
        'Possibility of full-time role later'
      ],
      applicationLink: 'https://forms.gle/mQC3HL662vBQLgKp7',
      email: 'dt.consult.common@gmail.com'
    },
    2: {
      title: 'Full Stack Developer',
      department: 'IT Services',
      type: 'Full-Time',
      location: 'Noida / Hybrid',
      stipend: '₹6-10 LPA',
      duration: 'Permanent',
      description: 'We are looking for an experienced Full Stack Developer to join our growing development team and work on cutting-edge web applications.',
      responsibilities: {
        frontend: [
          'Build responsive web applications using React',
          'Implement modern UI/UX designs',
          'Optimize application performance',
          'Write clean, maintainable code'
        ],
        backend: [
          'Develop RESTful APIs using Node.js',
          'Database design and optimization',
          'Implement authentication and security',
          'Deploy and maintain cloud infrastructure'
        ]
      },
      qualifications: [
        '2+ years experience in full stack development',
        'Strong knowledge of React, Node.js, and databases',
        'Experience with cloud platforms (AWS/Azure)',
        'Good problem-solving and communication skills'
      ],
      benefits: [
        'Competitive salary package',
        'Health insurance',
        'Flexible work hours',
        'Learning and development opportunities',
        'Modern office environment'
      ],
      applicationLink: 'https://forms.gle/mQC3HL662vBQLgKp7',
      email: 'dt.consult.common@gmail.com'
    },
    3: {
      title: 'Digital Marketing Specialist',
      department: 'Sales & Marketing',
      type: 'Full-Time',
      location: 'Noida / Remote',
      stipend: '₹4-7 LPA',
      duration: 'Permanent',
      description: 'Seeking a creative and data-driven Digital Marketing Specialist to develop and execute comprehensive digital marketing campaigns.',
      responsibilities: {
        marketing: [
          'Plan and execute digital marketing campaigns',
          'Manage social media platforms',
          'Create engaging content for various channels',
          'Monitor and analyze campaign performance'
        ],
        analytics: [
          'Track and report on KPIs',
          'Conduct market research',
          'Optimize campaigns based on data',
          'Prepare monthly performance reports'
        ]
      },
      qualifications: [
        '1-3 years experience in digital marketing',
        'Knowledge of SEO, SEM, and social media marketing',
        'Experience with Google Analytics and marketing tools',
        'Strong creative and analytical skills'
      ],
      benefits: [
        'Competitive compensation',
        'Remote work flexibility',
        'Professional development budget',
        'Creative work environment',
        'Performance bonuses'
      ],
      applicationLink: 'https://forms.gle/mQC3HL662vBQLgKp7',
      email: 'dt.consult.common@gmail.com'
    }
  };

  const job = jobData[id];

  if (!job) {
    return (
      <div className="job-not-found">
        <h2>Job Not Found</h2>
        <button onClick={() => navigate('/careers')}>Back to Careers</button>
      </div>
    );
  }

  return (
    <div className="job-details-page">
      {/* ...existing code from previous JobDetailsPage implementation... */}
      {/* Using the detailed job view from the earlier Careers component */}
      <div className="job-details-hero">
        <div className="container">
          <button className="back-button" onClick={() => navigate('/careers')}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 3l-7 7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Back to all jobs
          </button>
          
          <div className="job-details-header">
            <h1>{job.title}</h1>
            <div className="job-details-meta">
              <span className={`badge badge-${job.type.toLowerCase().replace(/[- ]/g, '')}`}>{job.type}</span>
              <span className="meta-divider">•</span>
              <span>{job.department}</span>
              <span className="meta-divider">•</span>
              <span>{job.location}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="job-details-content">
        <div className="container">
          <div className="job-details-layout">
            <div className="job-main-content">
              <section className="job-section">
                <h2>About the Role</h2>
                <p>{job.description}</p>
              </section>

              <section className="job-section">
                <h2>Responsibilities</h2>
                {Object.entries(job.responsibilities).map(([category, items]) => (
                  <div key={category} className="responsibility-group">
                    <h3>{category.charAt(0).toUpperCase() + category.slice(1)}</h3>
                    <ul>
                      {items.map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </section>

              <section className="job-section">
                <h2>Qualifications</h2>
                <ul>
                  {job.qualifications.map((qual, idx) => (
                    <li key={idx}>{qual}</li>
                  ))}
                </ul>
              </section>

              <section className="job-section">
                <h2>Benefits</h2>
                <ul>
                  {job.benefits.map((benefit, idx) => (
                    <li key={idx}>{benefit}</li>
                  ))}
                </ul>
              </section>
            </div>

            <div className="job-sidebar">
              <div className="apply-card">
                <h3>Apply Now</h3>
                <div className="apply-info">
                  <div className="info-row">
                    <span className="label">Salary</span>
                    <span className="value">{job.stipend}</span>
                  </div>
                  <div className="info-row">
                    <span className="label">Duration</span>
                    <span className="value">{job.duration}</span>
                  </div>
                </div>
                <div className="apply-actions">
                  <a href={job.applicationLink} target="_blank" rel="noopener noreferrer" className="btn-apply-main">
                    Apply via Form
                  </a>
                  <a href={`mailto:${job.email}?subject=Application for ${job.title}`} className="btn-apply-email">
                    Email CV
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobDetailsPage;
